var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback"},[_c('div',{staticClass:"center"},[_vm._m(0),_c('div',{staticClass:"res"},[_vm._v("恭喜！授权成功")]),_c('div',{staticClass:"sure",on:{"click":_vm.toWxBasics}},[_vm._v("确定")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('i',{staticClass:"iconfont icon-chenggong"})])
}]

export { render, staticRenderFns }